import React from "react";
import { Link, useLocation, useNavigate, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Package, ShoppingBag, LogOut, LayoutDashboard } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_brigadeiro-shop-10/artifacts/ro8wmkw2_Logo%20Confeitaria%20Divertido%20Rosa%20e%20Bege.png";

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const loc = useLocation();
  const navigate = useNavigate();

  if (loading) return <div className="py-32 text-center text-cocoa-soft">A carregar...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  const navItems = [
    { to: "/admin", icon: LayoutDashboard, label: "Início", end: true },
    { to: "/admin/produtos", icon: Package, label: "Produtos" },
    { to: "/admin/encomendas", icon: ShoppingBag, label: "Encomendas" },
  ];

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen flex bg-cream-deep">
      <aside className="w-64 bg-cocoa-dark text-cream flex flex-col">
        <div className="p-6 flex items-center gap-3 border-b border-cream/10">
          <img src={LOGO} alt="Caseirinhos" className="w-10 h-10 rounded-full" />
          <div>
            <div className="font-heading text-xl leading-none text-cream">Caseirinhos</div>
            <div className="text-[10px] uppercase tracking-widest text-rose mt-1">Admin</div>
          </div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {navItems.map((n) => {
            const active = n.end ? loc.pathname === n.to : loc.pathname.startsWith(n.to);
            return (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`admin-nav-${n.label.toLowerCase()}`}
                className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm transition-colors ${
                  active ? "bg-rose/20 text-cream" : "text-cream/70 hover:bg-cream/5 hover:text-cream"
                }`}
              >
                <n.icon className="w-4 h-4" />
                {n.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-cream/10">
          <div className="text-xs text-cream/60 mb-2 truncate">{user.email}</div>
          <button data-testid="admin-logout" onClick={handleLogout} className="w-full flex items-center justify-center gap-2 bg-cream/10 hover:bg-cream/20 text-cream py-2 rounded-full text-sm transition-colors">
            <LogOut className="w-4 h-4" /> Sair
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
